import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import styled from "styled-components/macro";

import { Constants, Carousel, Text, Button } from "../odc-ui";
import { Frame } from "@bitesite/react-figstrap";

import AutoGrowCardMemberImage from "../../assets/images/auto-grow-card-member.png";
import AutoGrowCard199Image from "../../assets/images/auto-grow-card-199.png";
import AutoGrowFlowDiagramVerticalPaddedImage from "../../assets/images/auto-grow-flow-diagram-vertical-padded.png";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 100px 0;

  @media ${Constants.style.mobileAndDownMediaQuery} {
    flex-direction: column-reverse;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    padding: 100px 40px;
  }
`;

const WriteupContainer = styled.div`
  width: 350px;
  padding: 75px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  @media ${Constants.style.mobileAndDownMediaQuery} {
    width: 100%;
    padding: 75px 0 0 0;
  }
`;

const WriteupContent = styled.div`
  padding-bottom: 100px;

  @media ${Constants.style.mobileAndDownMediaQuery} {
    padding: 0;
  }
`;

const CarouselContainer = styled.div`
  width: 500px;

  @media ${Constants.style.mobileAndDownMediaQuery} {
    width: 100%;
  }
`;

const AutoGrowPurchaseSection = ({ treatmentCategory }) => {
  const slideContents = [
    {
      image:
        treatmentCategory === "dermatology"
          ? AutoGrowCard199Image
          : AutoGrowCardMemberImage,
    },
    {
      image: AutoGrowFlowDiagramVerticalPaddedImage,
    },
  ];

  const renderCardWriteup = () => {
    let writeupText = "";
    let buyNowUrl = "";

    writeupText = (
      <Frame vertical gap={16}>
        <Text type="regular-bold">
          {treatmentCategory === "dermatology"
            ? "Start Saving $199 per month"
            : "Start Saving from $50 per month!"}
        </Text>
        <Frame vertical gap={12}>
          <Text type="regular-medium">
            Healthcoin<sup>®</sup> Auto Grow is your Healthcare Savings Account
            at Ottawa Derm & Surgery Centre. Simply choose your monthly
            investment amount and every month on this same date, your
            contribution and rewards will be deposited directly into your Auto
            Grow account.
          </Text>
          <Text type="regular-medium">
            Invest in Healthcoin<sup>®</sup> Auto Grow and watch your rewards
            grow effortlessly.
          </Text>
        </Frame>
      </Frame>
    );

    buyNowUrl = "/users/sign_up";

    return (
      <Frame vertical gap={20} alignItems="center">
        {writeupText}
        <Button type="dark" href={buyNowUrl}>
          Start now
        </Button>
      </Frame>
    );
  };

  return (
    <Container>
      <WriteupContainer>
        <WriteupContent>{renderCardWriteup()}</WriteupContent>
      </WriteupContainer>
      <CarouselContainer>
        <Carousel slideContents={slideContents} />
      </CarouselContainer>
    </Container>
  );
};

AutoGrowPurchaseSection.propTypes = {
  treatmentCategory: PropTypes.string.isRequired,
};

document.addEventListener("DOMContentLoaded", () => {
  const mountPoint = document.getElementById(
    "auto-grow-purchase-section-mount-point"
  );

  if (mountPoint) {
    const { treatmentCategory } = mountPoint.dataset;
    ReactDOM.render(
      <AutoGrowPurchaseSection treatmentCategory={treatmentCategory} />,
      mountPoint
    );
  }
});
